import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { handleAuthError, isAuthError } from "../utils/handleAuthError";

export default function useDeleteAccountFormik(initialEmail?: string) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Correo inválido")
      .required("El correo es obligatorio"),
    password: Yup.string()
      .min(6, "La contraseña debe tener al menos 6 caracteres")
      .required("La contraseña es obligatoria"),
  });

  const formik = useFormik({
    initialValues: {
      email: initialEmail || "",
      password: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        // Primero validar la contraseña autenticando al usuario
        await signInWithEmailAndPassword(auth, values.email, values.password);
        
        // Si la autenticación es exitosa, proceder con la eliminación
        const deleteAccountByEmail = httpsCallable(
          functions,
          "deleteAccountByEmail"
        );
        await deleteAccountByEmail({ 
          email: values.email,
          password: values.password 
        });
        
        // Cerrar sesión después de eliminar la cuenta
        await auth.signOut();
        
        toast.success("Cuenta eliminada exitosamente");
        navigate("/login");
      } catch (err: unknown) {
        if (isAuthError(err)) {
          handleAuthError();
          return;
        }
        console.error({ err });
        const errObj = err as { code?: string };
        let errorMessage = "Ocurrió un error al eliminar la cuenta";

        if (errObj?.code === "auth/wrong-password" || errObj?.code === "auth/invalid-credential") {
          errorMessage = "La contraseña es incorrecta";
        } else if (errObj?.code === "auth/user-not-found") {
          errorMessage = "No se encontró una cuenta con este correo electrónico";
        } else if (errObj?.code === "auth/invalid-email") {
          errorMessage = "El formato del correo electrónico no es válido";
        } else if ((err as Error)?.message) {
          errorMessage = (err as Error).message;
        }
        
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
  });

  return { ...formik, loading };
}

